import { render, staticRenderFns } from "./Cosmomo.vue?vue&type=template&id=96974c52&"
import script from "./Cosmomo.vue?vue&type=script&lang=js&"
export * from "./Cosmomo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports